export default __webpack_public_path__ + "static/media/avatar_lion8.d6135869.mp3";